// Create session
export const CREATE_SESSION_REQUEST = 'CREATE_SESSION_REQUEST';
export const CREATE_SESSION_SUCCESS = 'CREATE_SESSION_SUCCESS';
export const CREATE_SESSION_FAIL = 'CREATE_SEESION_FAIL';

// Update session
export const UPDATE_SESSION_REQUEST = 'UPDATE_SESSION_REQUEST';
export const UPDATE_SESSION_SUCCESS = 'UPDATE_SESSION_SUCCESS';
export const UPDATE_SESSION_FAIL = 'UPDATE_SESSION_FAIL';

// Retrieve session
export const RETRIEVE_SESSIONS_REQUEST = 'RETRIEVE_SESSIONS_REQUEST';
export const RETRIEVE_SESSIONS_SUCCESS = 'RETRIEVE_SESSIONS_SUCCESS';
export const RETRIEVE_SESSIONS_FAIL    = 'RETRIEVE_SESSIONS_FAIL';
